import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchBusinessUnitsByDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function BusinessUnitListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      setRows(await fetchBusinessUnitsByDomain(businessDomainId));
    } catch (e) {
      notify.apiError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessDomainId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleRowClick = (params) => {
    navigate(`/strategy/${businessDomainId}/business-units/${params.row.businessUnitId}`);
  };

  const columns = [
    { field: "businessDomainName", headerName: t("businessDomain.title"), width: 180 },
    { field: "businessUnitName", headerName: t("businessUnit.name"), flex: 1, minWidth: 200 },
    { field: "vision", headerName: t("businessUnit.vision"), flex: 1, minWidth: 150 },
  ];

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6">{t("businessUnit.list.title")}</Typography>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.businessUnitId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        onRowClick={handleRowClick}
        sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
        disableRowSelectionOnClick
      />
    </Box>
  );
}
